import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  editNickname: {
    description: 'Button aria-label for edit nickname',
    defaultMessage: 'Edit nickname',
    id: 'R3GHHj',
  },
  saveNickname: {
    description: 'Button aria-label for save nickname',
    defaultMessage: 'Save',
    id: 's9jess',
  },
  cancelEdit: {
    description: 'Button aria-label for cancel edit',
    defaultMessage: 'Cancel',
    id: 'k81KH/',
  },
  nicknameInputPlaceholder: {
    description: 'Input placeholder for nickname',
    defaultMessage: 'Enter nickname',
    id: 'z/4PIz',
  },
  saveError: {
    description: 'Error message when save fails',
    defaultMessage: 'Failed to save nickname. Please try again.',
    id: 'reBYrh',
  },
});
